import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as preferences from '../actions/preferences.actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap, filter } from 'rxjs/operators';
import { PreferencesService } from '../services/preferences.service';
import { AnalyticsService } from '../../shared/services/analytics.service';
var PreferencesEffects = /** @class */ (function () {
    function PreferencesEffects(actions$, preferencesSvc, analyticsSvc) {
        var _this = this;
        this.actions$ = actions$;
        this.preferencesSvc = preferencesSvc;
        this.analyticsSvc = analyticsSvc;
        this.getPreferencesOnStart$ = this.actions$.ofType(preferences.GET_TENANT_SETTINGS)
            .pipe(switchMap(function (action) {
            return _this.preferencesSvc.getTenantSpecificPreferences()
                .pipe(map(function (settings) { return new preferences.GetTenantPreferencesSuccess(settings); }), catchError(function (e) { return of(new preferences.GetTenantPreferencesFailed(e)); }));
        }));
        // @Effect()
        // setDefaultCatalogSortOrder$: Observable<Action> = this.actions$.pipe(
        //   ofType<preferences.GetTenantPreferencesSuccess>(preferences.GET_TENANT_SETTINGS_SUCCESS),
        //   map((action) => {
        //     const catalogSortOrders = action.payload.find(setting => setting.key === 'catalog_sort_orders')
        //     if (catalogSortOrders && catalogSortOrders.value && catalogSortOrders.value.length) {
        //       const defaultSortOrder = catalogSortOrders.value[0].key
        //       return new product.SetProductDefaultSortOrderSuccess(defaultSortOrder)
        //     }
        //   })
        // )
        this.getTenantPreferencesSuccess$ = this.actions$.pipe(ofType(preferences.GET_TENANT_SETTINGS_SUCCESS), map(function (action) {
            var trackingId = action.payload.find(function (setting) { return setting.key === 'ga_tracking_id'; });
            if (trackingId && trackingId.value) {
                return trackingId.value;
            }
            return '';
        }), filter(function (trackingId) { return !!trackingId; }), tap(function (trackingId) { return _this.analyticsSvc.init(trackingId); }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], PreferencesEffects.prototype, "getPreferencesOnStart$", void 0);
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Object)
    ], PreferencesEffects.prototype, "getTenantPreferencesSuccess$", void 0);
    return PreferencesEffects;
}());
export { PreferencesEffects };
